/* ToeFix V7.5: Animate the native <details> disclosure, not the actual
   Shopify express payment widgets. Delegated events also work after cart
   section re-rendering. If this file is unavailable, native <details> still works. */
(() => {
  const selector = '.cart-drawer .toefix-express-checkout--collapsible > summary';
  const active = new WeakMap();
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', (event) => {
    const summary = event.target.closest?.(selector);
    if (!summary) return;
    const details = summary.parentElement;
    const panel = details?.querySelector(':scope > .toefix-express-checkout__panel');
    if (!details || !panel || !panel.animate || prefersReducedMotion()) return;

    event.preventDefault();
    const state = active.get(details);
    const shouldOpen = !(state ? state.targetOpen : details.open);
    const startHeight = panel.getBoundingClientRect().height;
    state?.animation.cancel();
    active.delete(details);

    if (shouldOpen) details.open = true;
    details.toggleAttribute('data-express-closing', !shouldOpen);
    const endHeight = shouldOpen ? panel.scrollHeight : 0;
    // WAAPI animates element height without changing permanent inline styles.
    // Once finished, height returns to auto to accommodate real wallet iframes.
    const animation = panel.animate(
      [
        { height: `${shouldOpen ? (state ? startHeight : 0) : startHeight}px`, opacity: shouldOpen ? 0.55 : 1 },
        { height: `${endHeight}px`, opacity: shouldOpen ? 1 : 0.55 },
      ],
      { duration: shouldOpen ? 270 : 215, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
    );
    active.set(details, { targetOpen: shouldOpen, animation });
    animation.addEventListener('finish', () => {
      if (active.get(details)?.animation !== animation) return;
      active.delete(details);
      if (!shouldOpen) details.open = false;
      details.removeAttribute('data-express-closing');
      animation.cancel();
    }, { once: true });
  });
})();
